import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import React, { useEffect, useRef, useState } from 'react';
import SwipeableViews from 'react-swipeable-views';
import { handleLayoutConditionURLS } from '../effects/effects';
import { useParams } from 'react-router-dom';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3} className="my-1" >
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}



const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        // width: 500,
    },
}));

export default function TabComponent(props) {
    const classes = useStyles();
    const theme = useTheme();
    const [value, setValue] = useState(0);
    const tabRef = useRef(null);
    let sections = props && props.sections
    const [conSections, setConditionalSection] = useState([])
    const [refresh, setRefresh] = useState(false)
    const { steps, errorSections, fieldValues } = props
    const params = useParams()
    console.log("sections", sections, props)

    useEffect(() => {
        const handleConditions = async () => {
            Object.keys(props.hideOnconditions).length > 0 && Object.keys(props.hideOnconditions).forEach(async each => {
                let checkStatus = await handleLayoutConditionURLS(props.hideOnconditions[each].check, props.hideOnconditions[each].read, null, params)
                if (checkStatus === true) {
                    let tempSections = []
                    sections.map((section, index) => {
                        if (index.toString() === each) {
                            tempSections.push(section)
                        }
                    })
                    //  sections = tempSections
                    setConditionalSection(tempSections)
                    setRefresh(!refresh)
                }
            })
        }
        if (props && props.hideOnconditions) {
            handleConditions().catch(console.error);
        }
    }, [])

    // useEffect(() => {
    //     console.log("sections", sections, props.sections)
    //     if (props && props.sections && sections.length !== props.sections.length)
    //         setSection(props.sections)
    // }, [props.sections])


    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangeIndex = (index) => {
        setValue(index);
    };

    let tempSecs = conSections && conSections.length > 0 ? conSections : sections
    return (//className={classes.root}
        < >
            {refresh}
            {tempSecs && tempSecs.length > 1 ? <>     <AppBar position="static" color="inherit" 
            elevation={0}
            >
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                >
                    {tempSecs && tempSecs.map((tab, index) => {
                        return <Tab label={steps[index]} style={{ backgroundColor: errorSections[steps[index]] === true ? '#f44336' : '', color: errorSections[steps[index]] === true ? '#ffffff' : 'rgba(0, 0, 0, 0.54)' }} />
                    })}
                </Tabs>
            </AppBar>
                <SwipeableViews
                    style={{ height: window.innerHeight - 150 }}
                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                    index={value}
                    onChangeIndex={handleChangeIndex}
                >
                    {tempSecs && tempSecs.map((tab, index) => {
                        return <TabPanel value={value} index={index} dir={theme.direction}  >
                            {tab}
                        </TabPanel>
                    })}
                </SwipeableViews></> : <div className="m-3" style={{ height: window.innerHeight - 250 }} >
                {tempSecs}
            </div>
            }
        </>
    )
}